import { shouldShowDummyFeatures } from './dummy-feature-visibility-policy.mjs'

export function shouldShowLlmChatButton(mode) {
  return shouldShowDummyFeatures(mode)
}

export function getProjectNavbarToolsRightOffset(mode) {
  return shouldShowDummyFeatures(mode) ? '238px' : '158px'
}
